/* eslint react-hooks/exhaustive-deps: "warn" */

import NextLink from 'next/link';

import { useInt } from 'hooks/useInt';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './IndexAreas.module.scss';

import { IndexSection } from '../../atoms/IndexSection/IndexSection';
import { groupPath } from '../../paths';
import type { IndexAreasProps } from './IndexAreas.types';

export const IndexAreas = ({ groups, families, lang, className }: IndexAreasProps) => {
  const { t } = useInt();

  return (
    <IndexSection
      title={t('{areas} areas. {families} focused topic families.')
        .replace('{areas}', String(groups.length))
        .replace('{families}', String(families))}
      aside={t('Start broad, choose a family, then explore its connected topics.')}
      className={className}
    >
      <ul className={styles['grid']}>
        {groups.map((group, index) => (
          <li key={group.slug} className={styles['cell']}>
            <NextLink href={groupPath(group.slug, lang)} className={styles['card']}>
              <span className={styles['index']}>{String(index + 1).padStart(2, '0')}</span>

              <span className={styles['title']}>{group.title}</span>

              <span className={styles['description']}>{group.description}</span>

              <span className={styles['more']}>
                {t('Explore area')}
                <Icon type="arrow-forward" />
              </span>
            </NextLink>
          </li>
        ))}
      </ul>
    </IndexSection>
  );
};
